import {Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {DataTableComponent} from '../../../common/data-table/data-table.component';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AppConfigService} from '../../../../Services/app-config.service';
import {NotificationService} from '../../../../Services/notification.service';
import {AuditTrailModel} from '../../../../DataModels/audit-trail-model';
import {SysUserModel} from '../../../../DataModels/sys-user-model';
import {ResponseModel} from '../../../../DataModels/response-model';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {DataExportService} from '../../../../Services/dataExport.service';
import {Title} from '@angular/platform-browser';
import {EmailModel} from '../../../../DataModels/email-model';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-audit-trail-viewer',
  templateUrl: './audit-trail-viewer-form.component.html',
  styleUrls: ['./audit-trail-viewer-form.component.css'],
  standalone: false
})
export class AuditTrailViewerFormComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {

  // Email modal: payload for SendEmailModalComponent
  reportDataToSendInEmail: EmailModel = new EmailModel();

  constructor(
    private table: DataService,
    private notification: NotificationService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    public dataExport: DataExportService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  tableToGet = '';
  datasetName = '';
  // exportDT: Date;
  selectedBDay = '';
  selectedUser = 'all';
  eod: AuditTrailModel;
  auditDataCount = 0;
  // accounts$: Observable<any>;
  userCount = 0;
  itemSalesCount = 0;
  currencyCount = 0;
  isLoaded = false;
  // dayList: Array<AuditTrailModel>;
  dayList: any;
  userList: Array<SysUserModel>;
  selectedTable: any = 'all';
  tableList: any;

  // excel export: reference the shared DataTableComponent instance
  @ViewChild('auditTrailList') auditTrailList!: DataTableComponent;
  // access to select elements to update UI defaults programmatically
  @ViewChild('userSelect') userSelectRef!: ElementRef<HTMLSelectElement>;
  @ViewChild('datasetSelect') datasetSelectRef!: ElementRef<HTMLSelectElement>;

  // paging and toolbar state (shared DataTableComponent)

  dataTableReady = false;

  vm: any = {
    list: [],
  };

  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
  }

  ngOnDestroy(): void {
    // no legacy datatable resources to clean
  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Audit Trail Viewer @@AuditTrailViewer:Audit Trail Viewer`);
    // show preloader while initial reference data loads
    this.isLoaded = false;
    this.getBusinessDayData();
  }


  excelBtnOnClick() {
    const currentDate = new Date().toDateString();
    const tableEl = this.auditTrailList?.getTableElement();
    if (tableEl) {
      this.dataExport.exportToExcel(tableEl as any, 'Audit_Trail ' + currentDate + '.xlsx', currentDate);
    } else {
      this.notification.warning('Nothing to export: table not available');
    }
  }

  // define column and data fields in vars then set the grid to the values you want by type of dataset selected by user

  onChangeBDay(event): void {
    // alert(newVal);
    this.selectedBDay = event.target.value;
    // When Business Day changes, default filters to "All" for convenience
    this.selectedUser = 'all';
    this.selectedTable = 'all';
    // clear user list because date changed, then refetch
    this.userList = null; // clear store  list because date change
    this.getusers(); // now we know the date so lets go get stores for that date - binds list var on get
    this.getTables('all');
  }

  onChangeUser(event): void {
    // alert(newVal);
    this.selectedUser = event.target.value;
    // get list for tables now that we know user
    // console.log('selected user: ' + this.selectedUser);
    this.getTables(this.selectedUser);
    // console.log('finished onchguser');
  }

  onChangeDataset(event): void {
    this.selectedTable = event.target.value;
    // this.source.localdata = null;
    this.datasetName = '';
  }

  getWidth(): any {
    return '100%';
  }

  protected fetchPage(): void {
    this.getData(this.tableToGet || '');
  }

  getData(value: string) {

    this.tableToGet = value;

    this.datasetName = this.tableToGet;

    // show preloader while fetching data
    this.isLoaded = false;

    // Build paging params consistent with other list pages (zero-based pageNumber)
    const pageNumber = Math.max(0, (Number(this.page) || 1) - 1);
    const pageSize = Math.max(1, Number(this.pageSize) || this.appConfig.ListPageSize || 10);

    const paramString =
      'userId=' + this.selectedUser +
      '&recDate=' + this.selectedBDay +
      '&table=' + this.selectedTable +
      '&pageNumber=' + pageNumber +
      '&pageSize=' + pageSize;

    this.table.getDataWithParams(this.tableToGet + '/userdate', paramString).subscribe(
      (result: any) => {
        // Support both array and ResponseModel
        let rows: any[] = [];
        let total = 0;
        if (result && Array.isArray(result.Data)) {
          rows = result.Data;
          total = result.totalRecords || result.TotalRecords || rows.length || 0;
        } else if (Array.isArray(result)) {
          rows = result;
          total = rows.length;
        } else {
          rows = [];
          total = 0;
        }

        this.vm.list = rows;
        this.totalRecords = total;
        this.auditDataCount = total;
        this.userCount = total;
          this.dataTableReady = true;
          this.paginate(false);
        this.isLoaded = true;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.isLoaded = true;
        },
      () => {
        this.isLoaded = true;
      }
      );
  }

  getusers() {
    this.table.getData('sys_user').subscribe({
      next: (result: ResponseModel) => {
        this.userList = result.Data;
        this.selectedUser = 'all';
        try {
          // Reflect in the UI select if available
          this.userSelectRef?.nativeElement && (this.userSelectRef.nativeElement.value = 'all');
        } catch {
        }
        // If we have a business day, populate datasets for All Users immediately
        if (this.selectedBDay && this.selectedBDay !== '-1') {
          this.getTables('all');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.notification.error($localize`:Error loading User data @@errorLoadingUserData:Error loading User data`);
        console.log(error);
      },
      complete: () => {
      }
    });
  }

  getTables(user: string) {
    user = this.selectedUser;
    const sqlDate = new Date(this.selectedBDay).toDateString();
    this.table
      .getDataWithParams('audit_trail/tables', 'getTables=true&userId=' + user + '&recDate=' + sqlDate)
      .subscribe(
        (result) => {
          this.tableList = result;
          // Default dataset to "All Tables" when business day (and users) have been selected
          this.selectedTable = 'all';
          try {
            this.datasetSelectRef?.nativeElement && (this.datasetSelectRef.nativeElement.value = 'all');
          } catch {
          }
          // console.log('tables:' + result);
        },
        (error: HttpErrorResponse) => {
          this.notification.error(
            $localize`:Error loading Table data @@errorLoadingTableData:Error loading Table data`
          );
          console.log(error);
        },
        () => {}
      );
  }

  getBusinessDayData() {
    this.table.getDataWithParams('audit_trail/dates', 'getDates=true').subscribe(
      (result) => {
        this.dayList = result;
        // console.log('date:' + result);
        // this.userList = result;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        this.notification.error($localize`:Error loading EOD data @@errorLoadingEODData:Error loading EOD data`);
        console.log(error);
        this.isLoaded = true;
      },
      () => {
        this.isLoaded = true;
      }
    );
  }

  private printHtmlInIframe(html: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow?.document || iframe.contentDocument as Document;
    doc.open();
    doc.write(html);
    doc.close();
    setTimeout(() => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
      setTimeout(() => document.body.removeChild(iframe), 1000);
    }, 50);
  }

  private buildPrintHtml(): string {
    const list: any[] = Array.isArray(this.vm?.list) ? this.vm.list : [];
    const hasData = list.length > 0;

    const styles = `
      <style>
        @page { size: landscape; margin: 12mm; }
        @media print { .no-print { display: none !important; } }
        body { font-family: Arial, Helvetica, sans-serif; margin: 24px; }
        h1 { font-size: 18px; margin: 0 0 8px 0; }
        .muted { color: #666; }
        table { width: 100%; border-collapse: collapse; margin-top: 12px; }
        th, td { border: 1px solid #ccc; padding: 6px 8px; font-size: 12px; }
        th { background: #f6f6f6; text-align: left; }
      </style>
    `;

    const safe = (v: any) => (v === null || v === undefined ? '' : String(v));

    const formatDate = (d: any) => {
      try {
        const dt = new Date(d);
        if (isNaN(dt.getTime())) {
          return safe(d);
        }
        return dt.toLocaleDateString();
      } catch {
        return safe(d);
      }
    };

    const rowsHtml = hasData ? list.map((r, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${formatDate(r?.date_time)}</td>
        <td>${safe(r?.user_name)}</td>
        <td>${safe(r?.table_name)}</td>
        <td>${safe(r?.column_name)}</td>
        <td>${safe(r?.original_value)}</td>
        <td>${safe(r?.new_value)}</td>
        <td>${safe(r?.record_id)}</td>
        <td>${safe(r?.description)}</td>
        <td>${safe(r?.ip)}</td>
      </tr>
    `).join('') : '';

    const selectedDate = this.selectedBDay ? new Date(this.selectedBDay).toDateString() : '';
    const selectedUserDisplay = (() => {
      if (!this.selectedUser) {
        return '';
      }
      if (this.selectedUser === 'all') {
        return 'All Users';
      }
      const u = (this.userList || []).find(u => String(u?.id) === String(this.selectedUser));
      return u?.name || this.selectedUser;
    })();
    const selectedTableDisplay = this.selectedTable || 'All Tables';

    const headerHtml = `
      <div>
        <h1>Audit Trail</h1>
        ${selectedDate ? `<div class="muted">Business Day: ${selectedDate}</div>` : ''}
        ${selectedUserDisplay ? `<div class="muted">User: ${selectedUserDisplay}</div>` : ''}
        ${selectedTableDisplay ? `<div class="muted">Dataset: ${selectedTableDisplay}</div>` : ''}
        <div class="muted">Generated: ${new Date().toLocaleString()}</div>
      </div>
    `;

    const tableHtml = `
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>User</th>
            <th>Table</th>
            <th>Column</th>
            <th>Original</th>
            <th>Current</th>
            <th>Record ID</th>
            <th>Description</th>
            <th>User IP</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>
      ${!hasData ? '<div class="muted">No data</div>' : ''}
    `;

    return `
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Audit Trail</title>
          ${styles}
        </head>
        <body>
          ${headerHtml}
          ${tableHtml}
          <div class="no-print" style="margin-top:16px">
            <button onclick="window.print()">Print</button>
          </div>
        </body>
      </html>
    `;
  }

  print() {
    try {
      const list: any[] = Array.isArray(this.vm?.list) ? this.vm.list : [];
      if (!list.length) {
        this.notification.warning('Please load data before printing');
        return;
      }
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Audit Trail print failed', e);
      this.notification.error('Unable to print the Audit Trail report');
    }
  }

  // Build and open Send Email modal with current report as attachment
  sendReportEmail(): void {
    try {
      const list: any[] = Array.isArray(this.vm?.list) ? this.vm.list : [];
      if (!list.length) {
        this.notification.warning($localize`:Load data first @@loadDataFirst:Please load data before emailing`);
      }
      // Use same HTML as print to keep format identical
      const htmlDoc = this.buildPrintHtml();

      const dt = new Date();
      const ts = dt.toISOString().slice(0, 19).replace(/[:T]/g, '-');

      const selectedDate = this.selectedBDay ? new Date(this.selectedBDay).toDateString() : '';
      const subjectBits: string[] = ['Audit Trail'];
      if (selectedDate) {
        subjectBits.push(selectedDate);
      }
      if (this.selectedUser) {
        // subjectBits.push(`User ${this.selectedUser}`);
        const selectedUserName = (() => {
          if (!this.selectedUser) {
            return '';
          }
          if (this.selectedUser === 'all') {
            return 'All Users';
          }
          const u = (this.userList || []).find(u => String(u?.id) === String(this.selectedUser));
          return u?.name || this.selectedUser;
        })();
        subjectBits.push(`User ${selectedUserName}`);
      }

      if (this.selectedTable) {
        subjectBits.push(`Dataset ${this.selectedTable == 'all' ? 'All Tables' : this.selectedTable}`);
      }

      this.reportDataToSendInEmail = {
        toEmail: '',
        fromEmail: '',
        pdfHtml: htmlDoc,
        Subject: subjectBits.join(' - '),
        header_id: null,
        entity_id: null,
        body: $localize`:See attached report @@seeAttachedReport:Please see the attached report.`,
        activity_message: 'Audit trail emailed',
        FileName: `audit_trail_${ts}.pdf`,
        includeAttachment: true,
        attachment: null,
        print_orientation: '2',
        batch_type_id: null,
        convert_attachment_to: 'pdf',
      } as any;
    } catch (e) {
      console.error(e);
      this.notification.error($localize`:Unable to open email modal @@unableOpenEmailModal:Unable to open email modal`);
    }
  }

  onNavigate(aID: string) {
    // this.router.navigate(['admin/bank-form', {id: aID}]);
  }

  onClose() {
    this.router.navigate(['home']).then();
  }

  checkForChanges(): boolean {
    return false;
  }

}
